<template>
    <div :style="{height: isHaveCa ? '285px':'260px'}">
        <card class="news">
            <span slot="title">
                新闻公告
            </span>

            <el-link 
            slot="title-r"
            :underline="false" 
            type="primary"
            href="/news"
            >
                查看更多>
            </el-link>

            <list
                :data="tableData"
                :props="{title:'title', time:'infodate'}"
                v-loading.sync="loadingController"
                :href="hrefBuilder"
            ></list>
        </card>
    </div>
</template>

<script>
import List from '@components/sys/list';
import Card from '@components/sys/card';

export default {
    components: {
        List,
        Card,
    },
    data() {
        return {
            tableData: [],

            loadingController: false,
        };
    },
    computed: {
        isHaveCa(){
            return !!this.$siteConfig.caType
        }
    },
    methods: {
        queryData() {
            this.loadingController = true;

            this.$get(`${this.$store.state.api.webUrl}/index/information/getnewsnotice.json`,{
                featurecode:this.$siteConfig.planName
            }, data => {
                if(this.isHaveCa){
                    this.tableData = data;
                }else{
                    this.tableData = data.slice(0, 5);
                }
                this.loadingController = false;
            });
        },
        hrefBuilder(item) {
            var search = toSearch({
                infoid: item.infoid,
            });

            return `/news/detail${search}`;
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';
    .news{
        height: 100%;
    }

</style>